// 工人
const urlStatis = '/business/yhAttendanceStatistics/'
const api = {
  // web日签到汇总列表
  selectDayAttendanceSumList: urlStatis + 'selectDayAttendanceSumList',
  // 地图单人签到
  selecSingleAttendanceList: urlStatis + 'selecSingleAttendanceList',
  // 地图班组签到
  selecTeamAttendanceList: urlStatis + 'selecTeamAttendanceList'
}
export default api
